import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { useTheme } from "@mui/material";

import {
  closeTaskModal,
  setRefetchTasks,
  setLoading,
} from "app/store/tasks/slice/taskSlice";
import { useFetchAccountListQuery } from "app/store/dashboard/doctor_analytic/api/doctorAnalyticApi";
import { showSuccessToast, showErrorToast } from "utils/toast";
import { useSaveTaskMutation } from "app/store/tasks/api/taskApi";
import { patientApi } from "app/store/patient/api/patientApi";

const useTaskModal = (selectedTab) => {
  const { taskModalOpen, selectedTask, taskModalTitle, requestType } =
    useSelector((state) => state.task);
  const { data: availableAccounts } = useFetchAccountListQuery();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const [saveTask] = useSaveTaskMutation();

  const refetchTasks = () => {
    if (selectedTab !== "active" && requestType === "POST") {
      dispatch(setLoading(true));
      navigate("/tasks");
    } else dispatch(setRefetchTasks(true));
  };

  const onConfirm = async (formValues) => {
    try {
      const { message } = await saveTask({
        requestType,
        taskId: selectedTask.id,
        description: formValues.description,
        account: formValues.account,
        status: formValues.status,
        notes: formValues.notes,
        ...(formValues.patientId && { patientId: formValues.patientId }),
        ...(formValues.patientName && { patientName: formValues.patientName }),
        ...(formValues.patientSerialNumber && {
          patientSerialNumber: formValues.patientSerialNumber,
        }),
      });
      showSuccessToast(message);
      if (formValues.notes) {
        dispatch(patientApi.util.invalidateTags(["patientNotesHistory"]));
      }
      refetchTasks();
    } catch (error) {
      showErrorToast(error?.message || "An error occured, please try later.");
    } finally {
      dispatch(closeTaskModal());
    }
  };

  const onClose = () => {
    dispatch(closeTaskModal());
  };

  return {
    taskModalOpen,
    taskModalTitle,
    selectedTask,
    availableAccounts,
    requestType,
    onConfirm,
    onClose,
    theme,
  };
};

export default useTaskModal;
